import { Component, OnInit, OnDestroy } from '@angular/core';
import { SearchResult } from '../models/searchresult.model';
import { Subscription } from 'rxjs';
import { SearchService } from '../search.service';
import { FilterService } from '../filters/filter.service';
import { AlternativeSearchesAvailable } from '../models/alternativesearchesavailable.model';
import { DataError } from '../models/dataerror.model';
declare var $: any;

@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.css']
})
export class ResultsComponent implements OnInit, OnDestroy {
  filteredResults: SearchResult[];
  searchResults: SearchResult[];
  searchSubscription: Subscription;
  filterSubscription: Subscription;
  loadingSubscription: Subscription;
  sortSubscription: Subscription;
  errorSubscription: Subscription;
  showNoResults: boolean = false;
  showSearchHelp: boolean = true;
  isLoading: boolean = false;
  currentSortField: string = "Score";
  currentSortDirection: string = "A";
  dataError: DataError;
  constructor(private searchService: SearchService, private filterService: FilterService) { }

  ngOnInit() {
    this.errorSubscription = this.searchService.dataErrorOccurred.subscribe((error: DataError) => {
      this.dataError = error;
    });
    this.loadingSubscription = this.searchService.isLoading.subscribe((isLoading: boolean) => {
      this.isLoading = isLoading;
    });
    this.searchSubscription = this.searchService.searchResultsChanged
      .subscribe(
        (searchResults: SearchResult[]) => {
          this.currentSortDirection = "A";
          this.searchResults = searchResults;
          this.filteredResults = searchResults;
          this.runFilters(this.filterService.getAppliedFilters());
          this.runSort(this.currentSortField);
          setTimeout(() => { $('[data-toggle="tooltip"]').tooltip({ html: true }) }, 1000);
        }
      );
    this.filterSubscription = this.filterService.appliedFiltersChanged
      .subscribe(
        (filters: string[]) => {
          this.runFilters(filters);
          this.runSort(this.currentSortField);
        }
      );
  }
  ngOnDestroy() {
    this.loadingSubscription.unsubscribe();
    this.searchSubscription.unsubscribe();
    this.filterSubscription.unsubscribe();
    this.errorSubscription.unsubscribe();
  }
  changeSortDirection() {
    this.currentSortDirection = this.currentSortDirection === "A" ? "D" : "A";
    let temp  = this.filteredResults.reverse();
    this.filteredResults = temp.sort(
      (n1, n2) => {
        if (n1.IsMember && n2.IsMember) return 0;
        if (n1.IsMember && !n2.IsMember) return -1;
        return 1;
      }
    );
  }
  clearSearchResults() {
    this.filteredResults = [];
    this.searchResults = [];
    this.searchService.setAlternativeSearchesAvailable(new AlternativeSearchesAvailable(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0));
    this.showSearchHelp = true;
    this.currentSortField = "score";
    this.dataError = null;
  }
  runSort(sortField: string) {
    if (this.searchResults == null) return;
    if (this.searchResults.length == 0) return;
    this.currentSortDirection = "A";
    this.currentSortField = sortField;
    switch (sortField) {
      case "Company Name":
        this.sortByCompany();
        break;
      case "First Name":
        this.sortByFirstName();
        break;
      case "Last Name":
        this.sortByLastName();
        break;
      case "City":
        this.sortByCity();
        break;
      case "State":
        this.sortByState();
        break;
      default:
        this.sortByScore();
    }
  }
  runFilters(filters: string[]) {
    if (this.searchResults == null) {
      this.displayResultMessage();
      return;
    }
    if (this.searchResults.length == 0) {
      this.displayResultMessage();
      return;
    }
    let resultsArray = this.searchResults.slice(0);
    if (filters.length > 0 && this.searchResults.length > 0) {
      let filteredArray = [];
      for (const filter of filters) {
        filteredArray = [];
        for (const item of resultsArray) {
          if (item[filter].toString().toUpperCase() === 'TRUE') {
            filteredArray.push(item);
          }
        }
        resultsArray = filteredArray.slice(0);
      }
    }
    this.filteredResults = resultsArray.slice(0).sort(
      (n1, n2) => {
        if (n1.IsMember && n2.IsMember) return 0;
        if (n1.IsMember && !n2.IsMember) return -1;
        return 1;
      }
    );
    this.displayResultMessage();
  }
  displayResultMessage() {
    this.showSearchHelp = false;
    if (this.filteredResults.length === 0) {
      this.showNoResults = true;
    } else {
      this.showNoResults = false;
    }
  }
  sortByScore() {
    let temp = this.filteredResults.slice(0).sort(
      (n1, n2) => {
        if (n1.Score === n2.Score) return 0;
        if (n1.Score > n2.Score) return -1;
        return 1;
      }
    );
    this.filteredResults = temp.sort(
      (n1, n2) => {
        if (n1.IsMember && n2.IsMember) return 0;
        if (n1.IsMember && !n2.IsMember) return -1;
        return 1;
      }
    );
  }
  sortByCompany() {
    let temp = this.filteredResults.slice(0).sort(
      (n1, n2) => {
        if (n1.Company.toLowerCase() === n2.Company.toLowerCase()) return 0;
        if (n1.Company.toLowerCase() > n2.Company.toLowerCase()) return 1;
        return -1;
      }
    );
    this.filteredResults = temp.sort(
      (n1, n2) => {
        if (n1.IsMember && n2.IsMember) return 0;
        if (n1.IsMember && !n2.IsMember) return -1;
        return 1;
      }
    );
  }
  sortByFirstName() {
    let temp = this.filteredResults.slice(0).sort(
      (n1, n2) => {
        if (n1.FirstName.toLowerCase() === n2.FirstName.toLowerCase()) return 0;
        if (n1.FirstName.toLowerCase() > n2.FirstName.toLowerCase()) return 1;
        return -1;
      }
    );
    this.filteredResults = temp.sort(
      (n1, n2) => {
        if (n1.IsMember && n2.IsMember) return 0;
        if (n1.IsMember && !n2.IsMember) return -1;
        return 1;
      }
    );
  }
  sortByLastName() {
    let temp = this.filteredResults.slice(0).sort(
      (n1, n2) => {
        if (n1.LastName.toLowerCase() === n2.LastName.toLowerCase()) return 0;
        if (n1.LastName.toLowerCase() > n2.LastName.toLowerCase()) return 1;
        return -1;
      }
    );
    this.filteredResults = temp.sort(
      (n1, n2) => {
        if (n1.IsMember && n2.IsMember) return 0;
        if (n1.IsMember && !n2.IsMember) return -1;
        return 1;
      }
    );
  }
  sortByCity() {
    let temp = this.filteredResults.slice(0).sort(
      (n1, n2) => {
        if (n1.City.toLowerCase() === n2.City.toLowerCase()) return 0;
        if (n1.City.toLowerCase() > n2.City.toLowerCase()) return 1;
        return -1;
      }
    );
    this.filteredResults = temp.sort(
      (n1, n2) => {
        if (n1.IsMember && n2.IsMember) return 0;
        if (n1.IsMember && !n2.IsMember) return -1;
        return 1;
      }
    );
  }
  sortByState() {
    let temp = this.filteredResults.slice(0).sort(
      (n1, n2) => {
        if (n1.State === n2.State) return 0;
        if (n1.State > n2.State) return 1;
        return -1;
      }
    );
    this.filteredResults = temp.sort(
      (n1, n2) => {
        if (n1.IsMember && n2.IsMember) return 0;
        if (n1.IsMember && !n2.IsMember) return -1;
        return 1;
      }
    );
  }
}
